import { createFileRoute, Outlet } from "@tanstack/react-router"
import { getAppChrome, requireUserId } from "@/auth/rpc"
import { InventoryNav } from "../components/inventory-nav"

export const Route = createFileRoute("/_inventory-layout")({
  beforeLoad: async () => {
    await requireUserId({ data: { redirectTo: "/inventory" } })
  },
  loader: () => getAppChrome(),
  component: InventoryLayout,
})

function InventoryLayout() {
  const { sisterAppUrl } = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <InventoryNav sisterAppUrl={sisterAppUrl} />
      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
